// services/demande_service.ts
import { toast } from "react-toastify";
import axios from "axios";
import { Demande } from "../models/demandeAdmin";

const API_URL = process.env.REACT_APP_API_URL;

// Récupérer toutes les demandes
export const getAllDemande = async (): Promise<Demande[]> => {
  try {
    const response = await axios.get(`${API_URL}/demande`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200 && response.data) {
      return response.data.demandes as Demande[];
    } else {
      toast.error("Erreur lors de la récupération des demandes");
      return [];
    }
  } catch (error) {
    toast.error("Erreur lors de la récupération des demandes");
    throw axios.isAxiosError(error) && error.response
      ? error.response.data
      : new Error("Une erreur inconnue s'est produite");
  }
};

// Valider une demande (existant) -> appelle POST /demande/update/:id avec { status }
export const validateDemande = async (demandeId: number): Promise<Demande | null> => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Token non trouvé");
      return null;
    }

    const response = await axios.post(
      `${API_URL}/demande/update/${demandeId}`,
      { status: 3 },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    console.log(response);

    if (response.status === 200) {
      toast.success("Demande validée avec succès");
      return response.data.demande as Demande;
    } else {
      toast.error("Erreur lors de la validation de la demande");
      return null;
    }
  } catch (error) {
    toast.error("Erreur lors de la validation de la demande");
    throw axios.isAxiosError(error) && error.response
      ? error.response
      : new Error("Une erreur inconnue s'est produite");
  }
};

// Créer une demande d'info utilisateur (existant)
export const createDemandeUserInfo = async (data: any): Promise<string> => {
  try {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    if (!userId || !token) {
      toast.error("Utilisateur non connecté ou token manquant");
      return "Erreur";
    }

    let response;

    // ✅ Si data est un FormData (avec photo)
    if (data instanceof FormData) {
      console.log("📤 Envoi avec FormData (avec photo)");
      response = await axios.post(`${API_URL}/demande`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } else {
      // ✅ Sinon, envoi JSON normal (sans photo)
      console.log("📤 Envoi JSON (sans photo)");
      response = await axios.post(`${API_URL}/demande`, {
        content: data,
        typeDemande: "INFO_USER",
        user_id: userId,
      });
    }

    if (response.status === 200 || response.status === 201) {
      return "En attente de validation par l'admin";
    } else {
      return "Erreur";
    }
  } catch (error) {
    toast.error("Erreur lors de la création de la demande");
    throw axios.isAxiosError(error) && error.response
      ? error.response.data
      : new Error("Erreur inconnue");
  }
};

// Créer une demande PRO (multipart) -> POST /demande/professional
export const createProfessionalDemande = async (formData: FormData): Promise<any> => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${API_URL}/demande/professional`, formData, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status === 200 || response.status === 201) {
      toast.success("Demande professionnelle envoyée");
      return response.data;
    } else {
      toast.error("Erreur lors de l'envoi de la demande professionnelle");
      return null;
    }
  } catch (error) {
    toast.error("Erreur lors de l'envoi de la demande professionnelle");
    throw axios.isAxiosError(error) && error.response
      ? error.response
      : new Error("Erreur inconnue");
  }
};

// Rejeter une demande avec envoi d'email -> POST /demande/:id/reject
export const rejectDemande = async (id: number, reason: string): Promise<any> => {
  try {
    if (!reason || !reason.trim()) {
      toast.error("Le motif du rejet est obligatoire");
      return null;
    }

    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${API_URL}/demande/${id}/reject`, 
      { reason: reason.trim() }, 
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      toast.success("Demande rejetée et email envoyé à l'utilisateur");
      return response.data;
    } else {
      toast.error("Erreur lors du rejet de la demande");
      return null;
    }
  } catch (error) {
    const errorMessage = axios.isAxiosError(error) && error.response?.data?.message
      ? error.response.data.message
      : "Erreur lors du rejet de la demande";
    
    toast.error(errorMessage);
    throw axios.isAxiosError(error) && error.response
      ? error.response
      : new Error("Erreur inconnue");
  }
};